// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-customer-settings-preview-mobile-app {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: var(--fi-color-default);
  height: 100%;
  overflow: hidden;
  position: relative;
}

.fi-customer-settings-preview-mobile-app-header {
  background: var(--branded-color);
  color: #ffffff;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.fi-customer-settings-preview-mobile-app-header .fa {
  color: #ffffff;
}

.fi-customer-settings-preview-mobile-app-header-menu,
.fi-customer-settings-preview-mobile-app-header-search {
  display: inline-block;
  padding: 0.8em;
}

.fi-customer-settings-preview-mobile-app-customer-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 0.5em;
}

.fi-customer-settings-preview-mobile-app-tabs {
  display: flex;
  box-shadow: 0 0.1em 0.3em rgba(0, 0, 0, 0.25);
}

.fi-customer-settings-preview-mobile-app-tabs-tab {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0.6em 0.6em 0.3em;
  border-bottom: 0.5em solid transparent;
  font-size: 0.7em;
  text-align: center;
}

.fi-customer-settings-preview-mobile-app-tabs-tab-active {
  border-color: var(--branded-color);
}

.fi-customer-settings-preview-mobile-app-content {
  flex: 1;
  padding: 0.5em;
  overflow: hidden;
}

.fi-customer-settings-preview-mobile-app-content-card {
  padding: 0.5em;
  box-shadow: 0 0.05em 0.1em rgba(0, 0, 0, 0.25);
  border-radius: 0.07em;
  color: var(--fi-color-light);
}
.fi-customer-settings-preview-mobile-app-content-card + .fi-customer-settings-preview-mobile-app-content-card {
  margin-top: 0.5em;
}

.fi-customer-settings-preview-mobile-app-content-card-active {
  color: var(--fi-color-default);
}
.fi-customer-settings-preview-mobile-app-content-card-active .fi-customer-settings-preview-mobile-app-content-card-header-icon {
  color: var(--branded-color);
}
.fi-customer-settings-preview-mobile-app-content-card-active .fi-customer-settings-preview-mobile-app-content-card-header-text-sub {
  font-weight: bold;
}

.fi-customer-settings-preview-mobile-app-content-card-header {
  display: flex;
}

.fi-customer-settings-preview-mobile-app-content-card-header-icon {
  font-size: 2.7em;
}

.fi-customer-settings-preview-mobile-app-content-card-header-text {
  flex: 1;
  padding-left: 0.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fi-customer-settings-preview-mobile-app-content-card-content {
  margin-top: 0.7em;
  margin-bottom: 0.7em;
}

.fi-customer-settings-preview-mobile-app-content-card-footer {
  text-align: right;
}

.fi-customer-settings-preview-mobile-app-content-card-header-text-sub,
.fi-customer-settings-preview-mobile-app-content-card-content,
.fi-customer-settings-preview-mobile-app-content-card-footer {
  font-size: 0.8em;
}

.fi-customer-settings-preview-mobile-app-fab {
  position: absolute;
  right: 1em;
  bottom: 1em;
  height: 3em;
  width: 3em;
  background: var(--contrast-color);
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  align-items: center;
  text-align: center;
}
.fi-customer-settings-preview-mobile-app-fab > .fa {
  flex: 1;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./Source/app/appearance/customer-settings/customer-settings-preview-mobile-app/customer-settings-preview-mobile-app.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gCAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EACI,cAAA;AACR;;AAGA;;EAEI,qBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,6CAAA;AAAJ;;AAGA;EACI,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,sCAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kCAAA;AAAJ;;AAGA;EACI,OAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,8CAAA;EACA,qBAAA;EACA,4BAAA;AAAJ;AAEI;EACI,iBAAA;AAAR;;AAIA;EACI,8BAAA;AADJ;AAGI;EACI,2BAAA;AADR;AAII;EACI,iBAAA;AAFR;;AAMA;EACI,aAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,OAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;;;EAGI,gBAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAKI;EACI,OAAA;EACA,cAAA;AAHR","sourcesContent":[".fi-customer-settings-preview-mobile-app {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 16px;\r\n    color: var(--fi-color-default);\r\n    height: 100%;\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-header {\r\n    background: var(--branded-color);\r\n    color: #ffffff;\r\n    white-space: nowrap;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    .fa {\r\n        color: #ffffff;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-header-menu,\r\n.fi-customer-settings-preview-mobile-app-header-search {\r\n    display: inline-block;\r\n    padding: 0.8em;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-customer-name {\r\n    flex: 1;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    padding-left: 0.5em;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-tabs {\r\n    display: flex;\r\n    box-shadow: 0 0.1em 0.3em rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-tabs-tab {\r\n    flex: 1;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    padding: 0.6em 0.6em 0.3em;\r\n    border-bottom: 0.5em solid transparent;\r\n    font-size: 0.7em;\r\n    text-align: center;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-tabs-tab-active {\r\n    border-color: var(--branded-color);\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content {\r\n    flex: 1;\r\n    padding: 0.5em;\r\n    overflow: hidden;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card {\r\n    padding: 0.5em;\r\n    box-shadow: 0 0.05em 0.1em rgba(0, 0, 0, 0.25);\r\n    border-radius: 0.07em;\r\n    color: var(--fi-color-light);\r\n\r\n    + .fi-customer-settings-preview-mobile-app-content-card {\r\n        margin-top: 0.5em;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card-active {\r\n    color: var(--fi-color-default);\r\n\r\n    .fi-customer-settings-preview-mobile-app-content-card-header-icon {\r\n        color: var(--branded-color);\r\n    }\r\n\r\n    .fi-customer-settings-preview-mobile-app-content-card-header-text-sub {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card-header {\r\n    display: flex;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card-header-icon {\r\n    font-size: 2.7em;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card-header-text {\r\n    flex: 1;\r\n    padding-left: 0.5em;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card-content {\r\n    margin-top: 0.7em;\r\n    margin-bottom: 0.7em;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card-footer {\r\n    text-align: right;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-content-card-header-text-sub,\r\n.fi-customer-settings-preview-mobile-app-content-card-content,\r\n.fi-customer-settings-preview-mobile-app-content-card-footer {\r\n    font-size: 0.8em;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-app-fab {\r\n    position: absolute;\r\n    right: 1em;\r\n    bottom: 1em;\r\n    height: 3em;\r\n    width: 3em;\r\n    background: var(--contrast-color);\r\n    border-radius: 50%;\r\n    color: #ffffff;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n\r\n    > .fa {\r\n        flex: 1;\r\n        color: #ffffff;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
